import { uuidShort } from '@/utils'

export class BaseEntity {
  id!: string
  tenantId!: string

  get idShort() {
    return uuidShort(this.id)
  }
}

export interface Searchable {
  get searchString(): string
}

export const practiceTypePrimitiveTypes = [
  'string',
  'number',
  'int',
  'eur_currency',
  'boolean',
  'enum',
  'date',
  'datetime',
] as const
export type PrimitiveType = (typeof practiceTypePrimitiveTypes)[number]

export class NewSpecificField {
  key!: string
  displayName!: string
  type!: PrimitiveType
  visible!: boolean
  values!: string[]
  color!: string | null
  starred!: boolean
}

export class UpdateSpecificField {
  displayName?: string
  visible?: boolean
  values?: string[]
  color?: string | null
  starred?: boolean
}

export class SortSpecificFields {
  sortedKeys!: string[]
}

export class SpecificField implements Searchable {
  key!: string
  displayName!: string
  type!: PrimitiveType
  visible!: boolean
  values!: string[]
  color?: string
  starred?: boolean

  get searchString(): string {
    return this.key + ' ' + this.displayName
  }
}

export interface GetUrl {
  url: string
}
